import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[onlyDigitsDecimal]',
    standalone: false
})
export class OnlyDigitsDecimalDirective {
  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('input', ['$event'])
  onInputChange(event: Event) {
    const initialValue = this.el.nativeElement.value;
    let newValue = initialValue.replace(/[^0-9.-]/g, '');
    
    // Handle decimal points
    const parts = newValue.split('.');
    if (parts.length > 2) {
      newValue = parts[0] + '.' + parts.slice(1).join('');
    }

    // Handle negative signs
    const negParts = newValue.split('-');
    if (negParts.length > 2) {
      newValue = (negParts[0] === '' ? '-' : '') + negParts.slice(1).join('');
    }
    if (negParts.length === 2 && negParts[0] !== '') {
      newValue = negParts.join('');
    }

    this.el.nativeElement.value = newValue;
    if (this.control.control) {
      const isIncomplete = newValue === '' || newValue === '-' || newValue === '.' || newValue === '-.';
      const numericValue = isIncomplete ? null : parseFloat(newValue);
      this.control.control.setValue(numericValue, { emitModelToViewChange: false });
    }
    if (initialValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: Event) {
    const keyboardEvent = event as KeyboardEvent;
    const pattern = /[0-9.-]/;
    const inputChar = String.fromCharCode(keyboardEvent.charCode);

    if (!pattern.test(inputChar)) {
      keyboardEvent.preventDefault();
    }
  }
}

